import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    component: Home,
    children: [
      {
        path: "",
        name: "Categories",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Categories.vue"),
      },
      {
        path: ":id",
        name: "Items",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/Items.vue"),
      },
    ],
  },
  {
    path: "/allergen-table",
    name: "AllergenTable",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AllergenTable.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.query.lang == undefined) {
    next({ name: "Categories", query: { lang: "nl" } });
  } else {
    next();
  }
});

export default router;
